import {apiClient} from '../../../../lib/api-client';
import {MaterialOrderProductSearchResult} from "../types/MaterialOrderProductSearchResult"

export async function apiSearchMaterialOrderProducts(salesChannelID: number,
    productLineID: number, productTypeID?: number, sku?: string, description?: string, brandIDs?: string):
    Promise<MaterialOrderProductSearchResult> {
    try {
        return await apiClient.get("product/material-order-search",
            {
                params: {
                    salesChannelID: salesChannelID,
                    productLineID: productLineID,
                    productTypeID: productTypeID,
                    sku: sku,
                    description: description,
                    brandIDs: brandIDs
                }
            }) as MaterialOrderProductSearchResult;
    }
    catch (error: any) {
        return {
            isSuccess: false,
            errorMessage: error,
            products: [],
            edges: [],
            edgeDepths: [],
            lengths: [],
            miters: [],
            backers: [],
            substrates: []
        };
    }
};
